module.exports = __webpack_public_path__ + "img/chat_mascot_offline.16a18b93.svg";